import _createClass from "@babel/runtime/helpers/createClass";
export var ResourceType = /*#__PURE__*/function () {
  function ResourceType(resourceTypeModel) {
    this.resourceTypeModel = resourceTypeModel;
  }
  _createClass(ResourceType, [{
    key: "name",
    get: function get() {
      return this.resourceTypeModel.resourceName;
    }
  }, {
    key: "type",
    get: function get() {
      return this.resourceTypeModel.resourceType;
    }
  }]);
  return ResourceType;
}();